import type { VNode } from 'preact';

interface ImagePlaceholderProps {
  /** Aspect ratio as width/height, e.g. "16/9" */
  aspectRatio?: string;
  className?: string;
}

/** Greybox placeholder with diagonal cross pattern for image areas */
export function ImagePlaceholder({
  aspectRatio = '16/9',
  className = '',
}: ImagePlaceholderProps): VNode {
  return (
    <div
      className={`relative w-full overflow-hidden bg-neutral-300 border-2 border-dashed border-neutral-400 ${className}`}
      style={{ aspectRatio }}
    >
      {/* Diagonal cross pattern */}
      <svg
        className="absolute inset-0 w-full h-full text-neutral-400 opacity-60 pointer-events-none"
        preserveAspectRatio="none"
        viewBox="0 0 100 100"
        aria-hidden
      >
        <line x1="0" y1="0" x2="100" y2="100" stroke="currentColor" strokeWidth="2" />
        <line x1="100" y1="0" x2="0" y2="100" stroke="currentColor" strokeWidth="2" />
      </svg>
    </div>
  );
}
